/* 앱 헤더(desktop-nav, mobile-menu)와 랜딩 nav가 공유하는 단일 링크 목록.
 * 메뉴 추가/삭제/순서 변경은 여기서만 하면 세 곳에 동시 반영된다.
 * 스타일·액티브 처리(예: /trade/$symbol 활성 판정)는 각 소비처 책임. */
export const NAV_LINKS = [
	{ to: "/trade", labelKey: "nav.perp" },
	{ to: "/portfolio", labelKey: "nav.portfolio" },
	{ to: "/baggers", labelKey: "nav.markets" },
	{ to: "/learn", labelKey: "nav.learn" },
	{ to: "/referrals", labelKey: "nav.referrals" },
] as const;
